import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { ILocationParams, ILocationResponse, ILocationState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchCreateLocation = createAsyncThunk(
  'listLocations/fetchCreateLocation',
  async (params: ILocationParams, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.createLocation(params)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: ILocationState = {
  isLoading: false,
  response: null,
  error: null
}

const createLocationSlice = createSlice({
  name: 'states/show',
  initialState,
  reducers: {
    resetCreateLocation: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchCreateLocation.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchCreateLocation.fulfilled, (state, action: PayloadAction<ILocationResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchCreateLocation.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default createLocationSlice.reducer
export const { resetCreateLocation } = createLocationSlice.actions
